import styled, { css } from 'styled-components';

import {
  colors,
  typography,
} from '../../theme';

import {
  HeadingThree,
  Text,
} from '../../elements';

export const Wrapper = styled.li`
  break-inside: avoid;
  -webkit-column-break-inside: avoid;
  cursor: pointer;
  margin-bottom: ${40 / typography.BASE_FONT_SIZE}rem;
  overflow: visible;
  page-break-inside: avoid;
  position: relative;
  width: 100%;
  cursor: zoom-in;

  html.no-touch &:hover {
    div {
      color: ${colors.GREY__LINK};
    }
  }
`;

export const ImageWrapper = styled.div`
  margin: 0 1rem;
  position: absolute;
  right: 100%;
  top: 0;
`;

export const Image = styled.img`
  display: block;
  height: 100%;
  margin: 0;
  transform: translate3D(0,0,0);
  vertical-align: top;
  width: 100%;

  @media screen and (max-width: 666px) {
    width: auto;
    outline: 10px solid red;
    max-width: 100%;
    max-height: ${150 / typography.BASE_FONT_SIZE}rem;
    position: relative;
    margin: auto;
    margin-bottom: ${10 / typography.BASE_FONT_SIZE}rem;
    display: block;
  }

  &.inactive {
    transition: visibility 0s ease-in-out 0s;
    visibility: hidden;
  }

  &.active {
    transition: visibility 0s ease-in-out .3s;
    visibility: visible;
  }
`;

export const ZoomedImage = Image.extend`
  left: 50%;
  position: fixed;
  top: 50%;

  &.inactive {
    transition: transform .3s ease-in-out,
                visibility 0s ease-in-out .3s,
                z-index 0s ease-in-out .3s;
    z-index: 0;
  }

  &.active {
    transform: none !important;
    transition: transform .3s ease-in-out,
                visibility .3s ease-in-out,
                z-index .3s ease-in-out;
    z-index: 999;
  }
`;

export const MobileImage = styled.img`
  width: auto;
  max-height:  ${150 / typography.BASE_FONT_SIZE}rem;
  margin: auto;
  display: block;
  margin-bottom: ${30 / typography.BASE_FONT_SIZE}rem;

  @media screen and (min-width: 667px) {
    display: none;
  }

`;



export const Label = HeadingThree.extend``;

export const CaptionWrapper = styled.div`
  position: relative;
`;

export const Caption = Text.extend``;

export const ZoomCloseButton = styled.div`
  bottom: 0;
  cursor: zoom-out;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 9999;
`;



// WEBPACK FOOTER //
// ./src/components/EditorialListItem/style.js